import { CrmUsersViewModel } from "@Service/Models";

enum AuthenticationActions {
  Initialize = "INITIALIZE",
  RestoreToken = "RESTORE_TOKEN",
  SignIn = "SIGN_IN",
  SignOut = "SIGN_OUT",
  Loading = "LOADING",
}

type UserPayload = {
  fullName: string | null;
} & CrmUsersViewModel;

type TAuth = {
  isLoading: boolean;
  attributes: UserPayload | null;
  isAuthenticated: boolean;
  login: (a: CrmUsersViewModel | undefined) => void;
  initialize: () => void;
  logout: () => void;
  restoreToken?: (a: string) => void;
};

type TCurrentUser = {
  email: string;
  password: string;
};

interface IAuthReducer {
  type: AuthenticationActions;
  payload: UserPayload | null;
}

const AuthenticationReducer = (state: TAuth, action: IAuthReducer) => {
  switch (action.type) {
    case AuthenticationActions.Initialize:
      return {
        ...state,
        isLoading: false,
        attributes: action.payload,
        isAuthenticated: action.payload ? true : false,
      };
    case AuthenticationActions.RestoreToken:
      return {
        ...state,
        isLoading: false,
        attributes: action.payload,
        isAuthenticated: action.payload ? true : false,
      };
    case AuthenticationActions.SignIn:
      return {
        ...state,
        isLoading: false,
        attributes: action.payload,
        isAuthenticated: action.payload ? true : false,
      };
    case AuthenticationActions.SignOut:
      return {
        ...state,
        isLoading: false,
        attributes: null,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export {
  AuthenticationReducer,
  AuthenticationActions,
  TCurrentUser,
  TAuth,
  UserPayload,
};
